import Model from './utils/model'
import nexus from '@db2b/nexus-js'

export default {
  ...Model,
  options: {
    translations: {
      name: 'Commentaire'
    },
    name: 'comment',
    url: nexus.url('crm2', 'comments')
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/comment.js